import React from "react";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    education: "Education",
    present: "Present",
    no_education: "No education history listed",
    institution: "Institution",
    degree: "Degree",
    field_of_study: "Field of Study",
    location: "Location",
  },
  fr: {
    education: "Formation",
    present: "Présent",
    no_education: "Aucune formation renseignée",
    institution: "Établissement",
    degree: "Diplôme",
    field_of_study: "Domaine d'étude",
    location: "Lieu",
  },
};

export default function EducationTab({ candidate }) {
  const { t } = useComponentTranslation(translations);

  if (!candidate?.education?.length) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">🎓</div>
        <p className="text-gray-500">{t("no_education")}</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {candidate.education.map((edu) => (
        <div key={edu._id} className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex justify-between items-start mb-2">
            <div className="flex-1">
              <h3 className="text-sm font-semibold text-gray-900 mb-1">{edu.degree}</h3>
              <p className="text-sm text-gray-700 font-medium">{edu.institution}</p>
              {edu.field_of_study && (
                <p className="text-xs text-gray-600 mt-1">{edu.field_of_study}</p>
              )}
            </div>
            <span className="text-xs font-medium bg-purple-50 text-purple-700 px-2 py-1 rounded-lg border border-purple-100 whitespace-nowrap ml-4">
              {edu.from ? new Date(edu.from).toLocaleDateString() : ""} - {edu.to ? new Date(edu.to).toLocaleDateString() : t("present")}
            </span>
          </div>
          
          {(edu.location || edu.description) && (
            <div className="mt-2 pt-2 border-t border-gray-100 space-y-1">
              {edu.location && (
                <div>
                  <span className="text-xs text-gray-500">{t("location")}: </span>
                  <span className="text-xs text-gray-700 font-medium">{edu.location}</span>
                </div>
              )}
              {edu.description && (
                <p className="text-xs text-gray-600 mt-1">{edu.description}</p>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

